import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
} from '@angular/core';
import { InputBaseComponent } from 'src/app/_core';

@Component({
  standalone: true,
  selector: 'neopos-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [NgClass],
})
export class InputCheckboxComponent extends InputBaseComponent<boolean> {
  isExpanded = signal(false);

  @Input() additionalId = '';
  @Input() iconName = '';
  @Input() showLabel = true;
  @Input() showError = true;
  @Input({ required: true }) inputId!: string;

  @Output() focus: EventEmitter<FocusEvent> = new EventEmitter();
  @Output() blur: EventEmitter<FocusEvent> = new EventEmitter();

  toggle(): void {
    if (this.disabled) {
      return;
    }

    this.value = !this.value;
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggle();
    }
  }
}
